import React from 'react';
import { endpoint } from '../../../../views/pages/manage/common/constant';
import { dropdownMapping } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { descDropdown, ruleSubTypeDropdown, ruleSubTYpeDropdown, ruleTypeDropdown, weekBucketDropdown } from './constant';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import moment from 'moment';

export const getDropdown = async () => {
    const p = await Promise.all([
        dropdownMapping(endpoint.term.getAllActive, 'termDispValue', 'termDispValue'),
        dropdownMapping(endpoint.academic_career.getAllActive, 'academicCareerDispValue', 'academicCareerDispValue'),
    ])
    return {
        term: p[0],
        career: p[1],
        applicableComponents:descDropdown,
        ruleType:ruleTypeDropdown,
        ruleSubType:ruleSubTypeDropdown,
        weekBucket: weekBucketDropdown
    }
}

export const searchWeekWiseList = async ({ pageSize, page, filters }) => {
    const {career, term, effectiveFrom,effectiveTo,applicableComponents, weekBucket} = filters||{}
     const req={
    careerType: career?.value,
    term: term?.value,
    effectiveFrom: effectiveFrom&& moment(effectiveFrom).format('YYYY-MM-DD'), 
    effectiveTo: effectiveTo&& moment(effectiveTo).format('YYYY-MM-DD'),
    applicableComponents,
    weekBucket
    }
  return  fetchAllPostPromisedData(`${endpoint.refund.refundPoliciesSearch}?offset=${page}&pageSize=${pageSize}`,updateRequest(req))
}